export enum ChipChoiceType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum ChipChoiceState {
  Default = 'default',
  Active = 'active',
  Disabled = 'disabled'
}

export enum ChipChoiceSize {
  Minor = 'minor',
  SM = 'sm',
  RG = 'rg',
}
